import React from 'react';
import GenericSection from '../components/sections/GenericSection';
import SectionHeader from '../components/sections/partials/SectionHeader';
import { TERMS_AND_CONDITIONS_VERSION } from '../constants/legal';

const TermsAndConditions = () => {
  const sectionHeader = {
    title: 'Terms and Conditions',
    paragraph: `Current version: ${TERMS_AND_CONDITIONS_VERSION}`
  };

  return (
    <GenericSection>
      <div className="container-xs">
        <SectionHeader tag="h1" data={sectionHeader} />

        <h3>1. Introduction</h3>
        <p>These Terms govern your use of the Service. By using the Service, you agree to these Terms.</p>

        <hr />

        <h3>2. Service Description</h3>
        <p>The Service enables users to query WooCommerce databases using natural language, which is translated into SQL and visualised.</p>

        <hr />

        <h3>3. Eligibility</h3>
        <p>You must be authorised to access and use the WooCommerce store connected to the Service.</p>

        <hr />

        <h3>4. Acceptable Use</h3>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service for unlawful purposes</li>
          <li>Attempt to extract personal data unlawfully</li>
          <li>Reverse engineer or abuse the system</li>
          <li>Circumvent safeguards</li>
        </ul>

        <hr />

        <h3>5. Data Responsibility</h3>
        <p>You are responsible for:</p>
        <ul>
          <li>Ensuring lawful processing of your customer data</li>
          <li>Ensuring you have a legal basis for using the Service</li>
          <li>Verifying outputs before acting on them</li>
        </ul>

        <hr />

        <h3>6. AI-Generated Output Disclaimer</h3>
        <p>The Service uses AI to generate SQL queries and visualisations.</p>
        <ul>
          <li>Outputs may be inaccurate or incomplete</li>
          <li>You must validate results before use</li>
          <li>We are not liable for decisions based on outputs</li>
        </ul>

        <hr />

        <h3>7. Service Limitations</h3>
        <p>We do not guarantee:</p>
        <ul>
          <li>Accuracy of results</li>
          <li>Continuous availability</li>
          <li>Error-free operation</li>
        </ul>

        <hr />

        <h3>8. Security</h3>
        <p>You are responsible for maintaining the security of your WooCommerce account and credentials.</p>

        <hr />

        <h3>9. Liability Limitation</h3>
        <p>To the maximum extent permitted by law:</p>
        <ul>
          <li>The Service is provided &quot;as is&quot;</li>
          <li>We are not liable for data loss</li>
          <li>We are not liable for business decisions</li>
          <li>We are not liable for indirect or consequential damages</li>
        </ul>

        <hr />

        <h3>10. Termination</h3>
        <p>We may suspend or terminate access if:</p>
        <ul>
          <li>Terms are violated</li>
          <li>Security risks are identified</li>
        </ul>

        <hr />

        <h3>11. Changes</h3>
        <p>We may update these Terms from time to time.</p>

        <hr />

        <h3>12. Governing Law</h3>
        <p>These Terms are governed by applicable local law (to be specified based on your jurisdiction).</p>

        <hr />

        <h3>13. Contact</h3>
        <p className="mb-0">Exanta AI</p>
        <p className="mt-8">
          <a href="mailto:support@exanta.ai">support@exanta.ai</a>
        </p>
        <p className="mt-24 mb-0 text-sm text-color-low">
          Terms version: {TERMS_AND_CONDITIONS_VERSION}
        </p>
      </div>
    </GenericSection>
  );
};

export default TermsAndConditions;
